import { render, staticRenderFns } from "./PlantDetails.vue?vue&type=template&id=dd9caa02&"
import script from "./PlantDetails.vue?vue&type=script&lang=ts&"
export * from "./PlantDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports